import React from 'react'
import Typography from '@material-ui/core/Typography'
import { Link, } from 'react-router-dom'
import Button from '@material-ui/core/Button'

import RootLayout from '~/layout/RootLayout'

const NotFoundView = () => {
  return (
    <RootLayout>
      <Typography variant="body1">404 page not found.</Typography>
      <Button component={Link} to="/">
        Return to the website.
      </Button>
    </RootLayout>
  )
}

export default React.memo(NotFoundView)
